var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { isEmpty, keys } from "ramda";
import React, { useState } from "react";
import uuid from "uuid";
import { Link } from "react-router-dom";
import CountrySelect from "../common/CountrySelect";
import EnterpriseSelect from "../common/EnterpriseSelect";
import IndustrySelect from "../common/IndustrySelect";
import InputField from "../common/InputField";
function validate(user) {
    var errors = {};
    if (isEmpty(user.firstName)) {
        errors.firstName = "You must provide a value";
    }
    if (isEmpty(user.lastName)) {
        errors.lastName = "You must provide a value";
    }
    if (isEmpty(user.company)) {
        errors.company = "You must provide a value";
    }
    if (isEmpty(user.address)) {
        errors.address = "You must provide a value";
    }
    if (isEmpty(user.city)) {
        errors.city = "You must provide a value";
    }
    if (isEmpty(user.postalCode) && user.country === "DE") {
        errors.postalCode = "You must provide a value";
    }
    if (isEmpty(user.enterprises)) {
        errors.enterprises = "User must be associated with an enterprise";
    }
    if (!user.email) {
        errors.email = "Required";
    }
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(user.email)) {
        errors.email = "Invalid email address";
    }
    return errors;
}
var WizardFormFirstPage = function (props) {
    var _a;
    var _b = useState(props.oldCustomer
        ? props.oldCustomer
        : {
            firstName: "",
            lastName: "",
            email: "",
            address: "",
            company: "",
            industry: "Bar",
            phone: "",
            country: props.currentUser.country,
            isHost: false,
            role: "customer",
            vat: "19",
            city: "",
            postalCode: "",
            created: new Date(),
            updated: new Date(),
            id: uuid.v1(),
            agent: props.currentUser.id,
            enterprises: [],
        }), user = _b[0], setUser = _b[1];
    var errors = validate(user);
    var enterpriseSelectors = user.enterprises.map(function (e, key) { return (React.createElement(EnterpriseSelect, { readOnly: props.editMode, key: key, value: e, enterprises: props.enterprises, setEnterprise: function (id) {
            var enterprises = __spreadArrays(user.enterprises);
            if (id !== "none") {
                enterprises[key] = id;
            }
            else {
                enterprises.splice(key, 1);
            }
            setUser(__assign(__assign({}, user), { enterprises: enterprises }));
        }, error: key === 0 ? errors.enterprises : undefined })); });
    if (enterpriseSelectors.length < props.enterprises.length) {
        enterpriseSelectors.push(React.createElement(EnterpriseSelect, { readOnly: props.editMode, key: enterpriseSelectors.length, value: "none", enterprises: props.enterprises, setEnterprise: function (id) {
                var enterprises = __spreadArrays(user.enterprises);
                enterprises.push(id);
                setUser(__assign(__assign({}, user), { enterprises: enterprises }));
            }, error: enterpriseSelectors.length === 0 ? errors.enterprises : undefined }));
    }
    return (React.createElement("form", { className: "order__form_step", onSubmit: function (e) { return e.preventDefault(); } },
        React.createElement("div", { style: { display: "flex", width: "100%", justifyContent: "stretch" } },
            React.createElement("div", { className: "card-panel", style: { width: "100%" } },
                React.createElement(InputField, { label: "Email", type: "text", placeholder: "Email", disabled: props.editMode, meta: { touched: props.currentUser.email !== user.email, error: errors.email }, onChange: function (email) { return setUser(__assign(__assign({}, user), { email: email })); }, value: user.email }),
                React.createElement(InputField, { label: "First name", type: "text", placeholder: "", disabled: props.editMode, meta: { touched: props.currentUser.firstName !== user.firstName, error: errors.firstName }, onChange: function (firstName) { return setUser(__assign(__assign({}, user), { firstName: firstName })); }, value: user.firstName }),
                React.createElement(InputField, { label: "Last name", type: "text", placeholder: "", disabled: props.editMode, meta: { touched: props.currentUser.lastName !== user.lastName, error: errors.lastName }, onChange: function (lastName) { return setUser(__assign(__assign({}, user), { lastName: lastName })); }, value: user.lastName }),
                React.createElement(InputField, { label: "Company", type: "text", placeholder: "", disabled: props.editMode, meta: { touched: props.currentUser.company !== user.company, error: errors.company }, onChange: function (company) { return setUser(__assign(__assign({}, user), { company: company })); }, value: user.company }),
                React.createElement(InputField, { label: "Phone", type: "text", placeholder: "", disabled: props.editMode, meta: { touched: props.currentUser.phone !== user.phone, error: errors.phone }, onChange: function (phone) { return setUser(__assign(__assign({}, user), { phone: phone })); }, value: user.phone })),
            React.createElement("div", { className: "card-panel", style: { width: "100%" } },
                React.createElement(InputField, { label: "Address", type: "text", placeholder: "", disabled: props.editMode, meta: { touched: props.currentUser.address !== user.address, error: errors.address }, onChange: function (address) { return setUser(__assign(__assign({}, user), { address: address })); }, value: user.address }),
                React.createElement(InputField, { label: "City", type: "text", placeholder: "", disabled: props.editMode, meta: { touched: props.currentUser.city !== user.city, error: errors.city }, onChange: function (city) { return setUser(__assign(__assign({}, user), { city: city })); }, value: user.city }),
                user.country === "DE" && (React.createElement(InputField, { label: "Postal code", type: "text", placeholder: "", disabled: props.editMode, meta: {
                        touched: props.currentUser.postalCode !== user.postalCode,
                        error: errors.postalCode,
                    }, onChange: function (postalCode) { return setUser(__assign(__assign({}, user), { postalCode: postalCode })); }, value: user.postalCode })),
                React.createElement(CountrySelect, { value: user.country, onChange: function (e) { return setUser(__assign(__assign({}, user), { country: e.target.value })); }, enterprises: props.enterprises, readonly: props.editMode }),
                React.createElement(IndustrySelect, { value: (_a = user.industry) !== null && _a !== void 0 ? _a : "", onChange: function (e) { return setUser(__assign(__assign({}, user), { industry: e.target.value })); }, readonly: props.editMode }),
                enterpriseSelectors)),
        React.createElement("div", { className: "col s12 m12" },
            React.createElement("br", null),
            React.createElement(Link, { to: "/orders", className: "white btn-flat left red-text" }, "Cancel"),
            React.createElement("button", { type: "submit", disabled: keys(errors).length > 0, onClick: function () { return props.storeUser(user); }, className: "right teal btn-flat btn white-text next" }, "Next"))));
};
export default WizardFormFirstPage;



//////////////////
// WEBPACK FOOTER
// ./src/components/orders/OrderFormFirstStep.tsx
// module id = 1236
// module chunks = 0